// extracted by mini-css-extract-plugin
export default {"form_card":"styles_form_card__xvCxH","input_password":"styles_input_password__csHjb","button_cancel":"styles_button_cancel__UBkYM"};